import { __commonJSMin as e } from "../../../../../_virtual/_rolldown/runtime.js";
import { require_purify_cjs as t } from "../../../dompurify@3.4.0/bundled_deps/dompurify/dist/purify.cjs.js";
//#region ../../node_modules/.pnpm/isomorphic-dompurify@2.34.0_canvas@3.2.0/node_modules/isomorphic-dompurify/browser.js
var n = /* @__PURE__ */ e(((e, n) => {
	n.exports = self.DOMPurify || (self.DOMPurify = t().default || t());
}));
//#endregion
export default n();
export { n as require_browser };
